// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pt-dt","right":"styles_right__39a5b"};